<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-form ref="MyILDPFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header">
            <!--        -->
            {{ action }}
            ILDP {{ showImm + " " + showDir + " " + showVP + " " + showPres }}
            <v-spacer></v-spacer>
            <v-btn icon dark @click="close()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 900px" class="my-4">
            <v-alert
              v-if="!hasDirectHead"
              dense
              border="right"
              color="red"
              dismissible
              type="warning"
              class="text-caption"
            >
              You haven't set who's your direct head yet. Click
              <span @click="redirectTo()" class="clickme">here</span> to
              set.</v-alert
            >
            <v-row v-if="cardLoading">
              <v-col cols="12">
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="100%"
                  v-if="cardLoading"
                  type="card-avatar, article, actions"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row class="mt-2" v-else>
              <v-col cols="12" class="pa-0 pt-2 px-4" v-if="action == 'Add'">
                <v-autocomplete
                  :rules="action == 'Add' ? [formRules.required] : []"
                  v-model="ildpCalendarID"
                  dense
                  outlined
                  class="rounded-lg"
                  :item-text="concatYear"
                  @change="selectItem()"
                  item-value="id"
                  label="Calendar Year"
                  color="#6DB249"
                  :items="ildpCalendarList"
                >
                </v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" class="pa-0 pt-2 px-4 text-right">
                <v-btn
                  :disabled="isHrReceived == 1"
                  color="#6DB249"
                  class="white--text"
                  @click="addNewLND()"
                >
                  Add LND Activity</v-btn
                >
              </v-col> -->

              <!--  <v-col cols="12" class="pa-0 pt-2 px-4">
                <v-text-field
                  v-model="title"
                  :disabled="isHrReceived == 1"
                  dense
                  outlined
                  required
                  label="Title of Seminars, Workshops and Conferences"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pa-0 pt-2 px-4">
                <v-select
                  v-model="year"
                  :items="years"
                  :disabled="isHrReceived == 1"
                  dense
                  outlined
                  required
                  label="Year"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-select>
              </v-col>
              <v-col cols="12" class="pa-0 pt-2 px-4">
                <v-autocomplete
                  v-model="ld_actID"
                  :disabled="isHrReceived == 1"
                  dense
                  outlined
                  class="rounded-lg"
                  item-text="title"
                  @change="selectItem()"
                  item-value="id"
                  label="Learning and Development Activities"
                  color="#6DB249"
                  :items="lndActivity"
                >
                </v-autocomplete>
              </v-col> -->
              <!-- <v-col cols="12" class="pa-0 pt-2 px-4 text-right">
                <v-btn
                  v-if="isEditing"
                  color="red"
                  class="mr-2"
                  outlined
                  @click="cancel()"
                >
                  <v-icon>mdi-close-circle-outline</v-icon>
                  cancel
                </v-btn>
                <v-btn
                  :disabled="isHrReceived == 1"
                  v-if="!isEditing"
                  color="#6DB249"
                  class="white--text"
                  @click="addNewLND()"
                >
                  Add LND Activity</v-btn
                >
                <v-btn
                  v-if="isEditing"
                  color="#6DB249"
                  class="white--text"
                  @click="updateData()"
                >
                  Edit LND Activity</v-btn
                >
              </v-col> -->
              <v-col cols="12">
                <div class="elevation-4 rounded-lg">
                  <div class="d-flex">
                    <div
                      style="
                        border: 1px solid #519043;
                        width: 30%;
                        background-color: #519043;
                      "
                      class="text-center white--text rounded-tl-lg"
                    >
                      Learning and Development Activity
                    </div>
                    <div
                      style="
                        border: 1px solid #519043;
                        width: 70%;
                        background-color: #519043;
                      "
                      class="text-center white--text rounded-tr-lg"
                    >
                      (Indicate Target Completion Dates for Advanced Studies &
                      Skills Certification/Licensure/Eligibilities) <br />(Write
                      the specific title of the Seminar, Workshops, Training &
                      Conferences)
                    </div>
                  </div>
                  <div class="d-flex">
                    <div
                      style="border: 1px solid #9e9e9e; width: 30%"
                      class="text-center py-2 grey--text"
                    >
                      <span style="visibility: hidden">X</span>
                    </div>
                    <div
                      style="border: 1px solid #9e9e9e; width: 70%"
                      class="text-center grey--text d-flex"
                    >
                      <div
                        class="text-center grey--text year font-weight-bold d-flex justify-center align-center"
                        v-for="year in years"
                        :key="year"
                      >
                        {{ year }}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div
                      style="border: 1px solid #9e9e9e; width: 30%"
                      class="text-left pl-2 py-4 grey--text"
                    >
                      Seminars, Workshops, Training and Conferences
                    </div>
                    <div
                      style="border: 1px solid #9e9e9e; width: 70%"
                      class="text-center grey--text d-flex"
                    >
                      <div
                        class="text-center grey--text year"
                        v-for="yr in years"
                        :key="yr"
                      >
                        <div class="d-flex justify-start">
                          <div class="pa-2">
                            <v-tooltip right>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  elevation="4"
                                  small
                                  color="#6DB249"
                                  icon
                                  @click="addLnd(yr, 1)"
                                >
                                  <v-icon>mdi-plus</v-icon></v-btn
                                >
                              </template>
                              <span>Add for the year {{ yr }}</span>
                            </v-tooltip>
                          </div>
                        </div>
                        <div
                          v-for="(item, i) in ildpCreated"
                          :key="i"
                          class="d-flex"
                        >
                          <div
                            v-if="item.ld_actID == 1 && item.year == yr"
                            style="width: 80%"
                            class="pa-2 text-left lndList"
                          >
                            {{ item.title }}
                          </div>

                          <div
                            v-if="
                              item.ld_actID == 1 &&
                              item.year == yr &&
                              isHrReceived == 0
                            "
                            style="width: 20%"
                            class="px-2 text-right"
                          >
                            <v-btn @click="edit(item, i)" icon>
                              <v-icon>mdi-pencil</v-icon></v-btn
                            >
                            <v-btn @click="remove(item, i)" icon color="error">
                              <v-icon>mdi-trash-can-outline</v-icon></v-btn
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div
                      style="border: 1px solid #9e9e9e; width: 30%"
                      class="text-left pl-2 py-4 grey--text"
                    >
                      Advanced Studies/ Professional Development
                    </div>
                    <div
                      style="border: 1px solid #9e9e9e; width: 70%"
                      class="text-center grey--text d-flex"
                    >
                      <div
                        class="text-center grey--text year"
                        v-for="yr in years"
                        :key="yr"
                      >
                        <div class="d-flex justify-start">
                          <div class="pa-2">
                            <v-tooltip right>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  elevation="4"
                                  small
                                  color="#6DB249"
                                  icon
                                  @click="addLnd(yr, 2)"
                                >
                                  <v-icon>mdi-plus</v-icon></v-btn
                                >
                              </template>
                              <span>Add for the year {{ yr }}</span>
                            </v-tooltip>
                          </div>
                        </div>
                        <div
                          v-for="(item, i) in ildpCreated"
                          :key="i"
                          class="d-flex"
                        >
                          <div
                            v-if="item.ld_actID == 2 && item.year == yr"
                            style="width: 80%"
                            class="pa-2 text-left lndList"
                          >
                            {{ item.title }}
                          </div>
                          <div
                            v-if="
                              item.ld_actID == 2 &&
                              item.year == yr &&
                              isHrReceived == 0
                            "
                            style="width: 20%"
                            class="px-2 text-right"
                          >
                            <v-btn @click="edit(item, i)" icon>
                              <v-icon>mdi-pencil</v-icon></v-btn
                            >
                            <v-btn @click="remove(item, i)" icon color="error">
                              <v-icon>mdi-trash-can-outline</v-icon></v-btn
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div
                      style="border: 1px solid #9e9e9e; width: 30%"
                      class="text-left pl-2 py-4 grey--text"
                    >
                      Skills Certification/ Licensure/Eligibilities
                    </div>
                    <div
                      style="border: 1px solid #9e9e9e; width: 70%"
                      class="text-center grey--text d-flex"
                    >
                      <div
                        class="text-center grey--text year"
                        v-for="yr in years"
                        :key="yr"
                      >
                        <div class="d-flex justify-start">
                          <div class="pa-2">
                            <v-tooltip right>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  elevation="4"
                                  small
                                  color="#6DB249"
                                  icon
                                  @click="addLnd(yr, 3)"
                                >
                                  <v-icon>mdi-plus</v-icon></v-btn
                                >
                              </template>
                              <span>Add for the year {{ yr }}</span>
                            </v-tooltip>
                          </div>
                        </div>
                        <div
                          v-for="(item, i) in ildpCreated"
                          :key="i"
                          class="d-flex"
                        >
                          <div
                            v-if="item.ld_actID == 3 && item.year == yr"
                            style="width: 80%"
                            class="pa-2 text-left lndList"
                          >
                            {{ item.title }}
                          </div>
                          <div
                            v-if="
                              item.ld_actID == 3 &&
                              item.year == yr &&
                              isHrReceived == 0
                            "
                            style="width: 20%"
                            class="px-2 text-right"
                          >
                            <v-btn @click="edit(item, i)" icon>
                              <v-icon>mdi-pencil</v-icon></v-btn
                            >
                            <v-btn @click="remove(item, i)" icon color="error">
                              <v-icon>mdi-trash-can-outline</v-icon></v-btn
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div
                      style="border: 1px solid #9e9e9e; width: 30%"
                      class="text-left pl-2 py-4 grey--text rounded-bl-lg"
                    >
                      Research, Extension, Production, Administration and Other
                      Interests
                    </div>
                    <div
                      style="border: 1px solid #9e9e9e; width: 70%"
                      class="text-center grey--text d-flex rounded-br-lg"
                    >
                      <div
                        class="text-center grey--text year"
                        v-for="yr in years"
                        :key="yr"
                      >
                        <div class="d-flex justify-start">
                          <div class="pa-2">
                            <v-tooltip right>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  elevation="4"
                                  small
                                  color="#6DB249"
                                  icon
                                  @click="addLnd(yr, 4)"
                                >
                                  <v-icon>mdi-plus</v-icon></v-btn
                                >
                              </template>
                              <span>Add for the year {{ yr }}</span>
                            </v-tooltip>
                          </div>
                        </div>
                        <div
                          v-for="(item, i) in ildpCreated"
                          :key="i"
                          class="d-flex"
                        >
                          <div
                            v-if="item.ld_actID == 4 && item.year == yr"
                            style="width: 80%"
                            class="pa-2 text-left lndList"
                          >
                            {{ item.title }}
                          </div>
                          <div
                            v-if="
                              item.ld_actID == 4 &&
                              item.year == yr &&
                              isHrReceived == 0
                            "
                            style="width: 20%"
                            class="px-2 text-right"
                          >
                            <v-btn @click="edit(item, i)" icon>
                              <v-icon>mdi-pencil</v-icon></v-btn
                            >
                            <v-btn @click="remove(item, i)" icon color="error">
                              <v-icon>mdi-trash-can-outline</v-icon></v-btn
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="pt-5" v-if="action != 'Submit'">
                <h1>Signatories</h1>
              </v-col>
              <v-col cols="12" class="pa-0 pt-4 px-4" v-if="action != 'Submit'">
                <v-text-field
                  v-if="showImm"
                  v-model="head_name"
                  readonly
                  dense
                  outlined
                  required
                  label="Immediate Supervisor"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pa-0 pt-2 px-4" v-if="action != 'Submit'">
                <div
                  class="text-caption blue--text pb-2"
                  v-if="showDir && action != 'View'"
                >
                  <i
                    >Note: Please select in the dropdown if the pre-selected
                    Dean/Director is wrong.</i
                  >
                </div>
                <v-autocomplete
                  v-if="showDir"
                  :rules="showDir ? [formRules.required] : []"
                  :readonly="action != 'Add' && action != 'Update'"
                  dense
                  outlined
                  class="rounded-lg"
                  item-text="name"
                  item-value="id"
                  label="Dean/Director"
                  color="#6DB249"
                  v-model="dean_userID"
                  :items="deanDirList"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                class="pa-0 pt-2 px-4"
                v-if="action != 'Submit' && showVP"
              >
                <v-autocomplete
                  :rules="[formRules.required]"
                  dense
                  outlined
                  class="rounded-lg"
                  item-text="name"
                  item-value="userID"
                  label="Vice President"
                  color="#6DB249"
                  v-model="vp_userID"
                  :items="vpList"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                class="pa-0 pt-2 px-4"
                v-if="action != 'Submit' && showPres"
              >
                <v-text-field
                  v-model="president_name"
                  readonly
                  dense
                  outlined
                  required
                  label="President"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-text-field>
                <!-- <v-autocomplete
                  :rules="[formRules.required]"
                  dense
                  outlined
                  class="rounded-lg"
                  item-text="name"
                  item-value="id"
                  label="President"
                  v-model="president_userID"
                  color="#6DB249"
                  :items="usersList"
                >
                </v-autocomplete> -->
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-5" v-if="!cardLoading">
            <v-fab-transition>
              <v-menu top>
                <template v-slot:activator="{ on }">
                  <v-btn left color="#519043" outlined v-on="on">
                    Remarks
                  </v-btn>
                </template>

                <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                  <v-card-title class="dialog-header white--text">
                    <span class="text-h6">Remarks</span>
                  </v-card-title>
                  <v-card-text
                    class="py-0"
                    style="
                      background-color: white;
                      height: 300px;
                      overflow-y: auto;
                    "
                  >
                    <v-timeline dense v-if="remarksData.length > 0">
                      <v-timeline-item
                        v-for="item in remarksData"
                        :key="item.id"
                        small
                        color="#519043"
                        icon="mdi-comment-processing-outline"
                        fill-dot
                      >
                        <v-alert :value="true">
                          <div class="text-h6">
                            {{
                              $store.getters.getUserData.id ==
                              item.remarks_maker_userID
                                ? "You"
                                : item.remarks_by
                            }}
                          </div>
                          <div class="text-body-1">
                            {{ item.message }}
                          </div>
                          <div class="text-caption">
                            <i>{{ formatDate(item.created_at) }}</i>
                          </div>
                        </v-alert>
                      </v-timeline-item>
                    </v-timeline>
                    <v-timeline dense v-if="remarksData.length == 0">
                      <v-timeline-item
                        small
                        color="#519043"
                        icon="mdi-comment-processing-outline"
                        fill-dot
                      >
                        <v-alert :value="true">
                          <div class="text-body-1">No remarks found.</div>
                        </v-alert>
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-fab-transition>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="close()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Close
            </v-btn>
            <v-btn
              v-if="action == 'Add'"
              color="#519043"
              class="white--text"
              @click="add()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>

            <v-btn
              v-if="action == 'Submit'"
              color="#519043"
              class="white--text"
              @click="confirmSubmit()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Submit
            </v-btn>

            <v-btn
              v-if="action == 'Update' && isHrReceived == 0"
              color="#519043"
              class="white--text"
              @click="update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- ILDP SELECTION DIALOG -->
    <v-dialog
      v-model="lndSelectionDialog"
      eager
      scrollable
      persistent
      max-width="800px"
      transition="dialog-bottom-transition"
    >
      <v-form ref="lndSelectionFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>{{ internal_action }} Learning and Development Activity</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="lndSelectionDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 800px" class="my-4">
            <v-row>
              <v-col cols="12" class="pa-0 pt-2 px-4 mt-5">
                <v-textarea
                  v-model="title"
                  :disabled="isHrReceived == 1"
                  dense
                  :rules="[formRules.required]"
                  outlined
                  required
                  :label="`Title of ${getTitleForLabel}`"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-textarea>
              </v-col>
              <v-col v-if="internal_action == 'Add'">
                <div style="border: 1px solid grey" class="rounded-lg pa-2">
                  <div class="text-caption">Select Years to add</div>
                  <div class="d-flex justify-space-around">
                    <div v-for="i in years" :key="i">
                      <v-checkbox
                        :value="i"
                        :checked="i == year"
                        :readonly="i == year"
                        v-model="addToYears"
                        :label="i.toString()"
                      ></v-checkbox>
                    </div>
                  </div>
                </div>
              </v-col>
              <!-- <v-col cols="12" class="pa-0 pt-2 px-4">
                <v-select
                  v-model="year"
                  :items="years"
                  :rules="[formRules.required]"
                  :disabled="isHrReceived == 1"
                  dense
                  outlined
                  required
                  label="Year"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-select>
              </v-col>
              <v-col cols="12" class="pa-0 pt-2 px-4">
                <v-autocomplete
                  v-model="ld_actID"
                  :rules="[formRules.required]"
                  :disabled="isHrReceived == 1"
                  dense
                  outlined
                  class="rounded-lg"
                  item-text="title"
                  item-value="id"
                  label="Learning and Development Activities"
                  color="#6DB249"
                  :items="lndActivity"
                >
                </v-autocomplete>
              </v-col> -->
            </v-row>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeILPDSelection()">
              Close
            </v-btn>
            <v-btn
              v-if="internal_action == 'Add'"
              color="#519043"
              class="white--text"
              @click="addILPD()"
            >
              Add
            </v-btn>
            <v-btn
              v-if="internal_action == 'Update'"
              color="#519043"
              class="white--text"
              @click="updateData()"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- END OF SELCTION DIALOG -->
    <!-- CONFIRM DELETE DIALOG -->
    <v-dialog v-model="confirmDeleteDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-overline mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to remove this and proceed?
            </p>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()"> Close </v-btn>
          <v-btn color="green" class="white--text" @click="proceedDelete()">
            YES
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END OF CONFIRM DELETE DIALOG -->
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>

    <WarningDialog
      :msg="warningMsg"
      v-on:yes="yes"
      v-on:no="no"
      :loading="btnLoading"
    />
  </div>
</template>

<script>
import WarningDialog from "../Views/WarningDialog.vue";

export default {
  components: {
    WarningDialog,
  },
  props: {
    data: null,
    action: null,
    isHrReceived: null,
  },

  data() {
    return {
      warningMsg: null,
      cardLoading: true,
      btnLoading: false,
      showImm: true,
      showDir: true,
      showVP: true,
      showPres: true,
      dialog: false,
      myIldpID: null,
      id: null,
      title: null,
      year: null,
      ld_actID: null,
      ildpCalendarID: null,
      isEditing: false,
      ildpCalendarList: [],
      head_userID: null,
      head_name: null,
      dean_userID: null,
      dean_name: null,
      hasDirectHead: null,
      vp_userID: null,
      president_userID: null,
      president_name: null,
      ildpCalendarSelected: [],
      itemsToRemove: [],
      usersList: [],
      indexToUpdate: null,
      years: [],
      ildpCreated: [],
      vpList: [],
      lndActivity: [
        {
          id: 1,
          title: "Seminars, Workshops, Training and Conferences",
        },
        {
          id: 2,
          title: "Advanced Studies/ Professional Development",
        },
        {
          id: 3,
          title: "Skills Certification/ Licensure/Eligibilities",
        },
        {
          id: 4,
          title:
            "Research, Extension, Production, Administration and Other Interests",
        },
      ],
      lndSelectionDialog: false,
      confirmDeleteDialog: false,
      internal_action: null,
      itemToDelete: null,
      itemIndexToDelete: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      remarksData: [],
      addToYears: [],
      myPosition: null,
      deanDirList: [],
    };
  },
  watch: {
    data: {
      handler(data) {
        this.cardLoading = true;
        console.log("Data", data);
        this.loadAllRequest();
        this.title = null;
        this.year = null;
        this.ld_actID = null;

        this.dialog = true;

        if (data.id != null) {
          this.ildpCalendarID = data.id;
          this.myIldpID = data.myIldpID;
          this.head_userID = data.head_approver
            ? data.head_approver.toString()
            : null;
          this.dean_userID = data.dean_approver
            ? data.dean_approver.toString()
            : null;

          this.vp_userID = data.vp_approver
            ? data.vp_approver.toString()
            : null;
          this.showImm = data.head_approver ? true : false;
          this.showDir = data.dean_approver ? true : false;
          this.showVP = data.vp_approver ? true : false;
          this.loadData(data.id, data.yearFrom, data.yearTo);
          this.loadRemarks(data.myIldpID);
        } else {
          this.$refs.MyILDPFormref.reset();
          this.ildpCalendarID = null;
          this.head_userID = null;
          this.vp_userID = null;
          this.ildpCreated = [];
          this.dean_userID = null;
          this.years = [];
        }
        // this.selectItem();
      },

      deep: true,
    },
    head_userID: {
      handler(data) {
        // console.log("here1", this.getMyRole);
        if (!this.checkRoles(this.getMyRole)) {
          if (this.myPosition.is_teaching == 1 && this.getMyRole == 2) {
            // console.log("here1");

            this.setDeanDir(data);
          } else {
            // console.log("here2");

            this.showImm = true;
            this.getOffice(data);
          }
        } else {
          // console.log("here3");
          if (!this.dean_userID) {
            this.setDeanDir(data);
          }
        }
      },
      deep: true,
    },
    dean_userID: {
      handler(data) {
        console.log("DEAN ", data);
        if (!data) {
          if (this.getVpListLen > 0) {
            const userIndex = this.vpList.findIndex(
              (user) => user.userID == data,
            );

            if (userIndex != -1) {
              this.vp_userID = data.toString();
              this.showDir = true;
              this.showVP = true;
              this.showPres = true;
              console.log("CALLED -1 userINdex");
            } else {
              this.showDir = false;
              this.showVP = true;
              this.showPres = true;
              console.log("CALLED this.getVP");
              this.getVP(data);
            }
          }
        }
      },
      deep: true,
    },

    president_userID: {
      handler(data) {
        if (data && data == this.dean_userID) {
          console.log("CALLED PRESIDENT");
          this.showImm = false;
          this.showVP = false;
          this.showDir = false;
          this.showPres = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    getVpListLen() {
      return this.vpList.length;
    },
    getMyRole() {
      console.log(this.$store.state.user.user.user_roleID);
      return this.$store.state.user.user.user_roleID;
    },

    getTitleForLabel() {
      let title = "";
      if (this.ld_actID) {
        title = this.lndActivity[this.ld_actID - 1].title;
      }
      return title;
    },
  },
  methods: {
    close() {
      this.dialog = false;

      this.eventHub.$emit("closeMyIldpDialog", false);
    },

    yes() {
      this.btnLoading = true;
      this.submit();
    },
    no() {
      this.warningMsg = null;
    },

    redirectTo() {
      var usertype = this.$store.state.user.usertype.description;
      if (this.$store.state.user.user.user_roleID == 5) {
        this.$router.push("/superadmin/my-direct-head");
      } else {
        this.$router.push("/" + usertype.toLowerCase() + "/my-direct-head");
      }
    },

    loadRemarks(id) {
      this.axiosCall("/remarks/" + id + "/MY ILPD", "GET").then((res) => {
        if (res.data) {
          console.log("Remaeks", res.data);
          this.remarksData = res.data;
        }
      });
    },

    getUser(id) {
      for (let i = 0; i < this.usersList.length; i++) {
        if (this.usersList[i].id == id) {
          return this.usersList[i];
        }
      }
    },

    selectItem() {
      this.years = [];
      for (let i = 0; i < this.ildpCalendarList.length; i++) {
        const element = this.ildpCalendarList[i];
        if (element.id == this.ildpCalendarID) {
          this.ildpCalendarSelected = element;
        }
      }
      for (
        let i = parseInt(this.ildpCalendarSelected.yearFrom);
        i <= parseInt(this.ildpCalendarSelected.yearTo);
        i++
      ) {
        this.years.push(i);
      }
    },
    concatYear(item) {
      return item.yearFrom + " - " + item.yearTo;
    },
    getILDPCalendar(res) {
      // this.axiosCall("/my-ildp/getILDPYear", "GET").then((res) => {
      this.ildpCalendarList = res.data;
      // });
    },

    loadData(id, yearFrom, yearTo) {
      this.axiosCall("/ildp/loadILDPYear/" + id, "GET").then((res) => {
        this.ildpCreated = res.data;
        console.log(this.ildpCreated);

        this.years = [];
        // for (let i = 0; i < this.ildpCalendarList.length; i++) {
        //   const element = this.ildpCalendarList[i];
        //   if (element.id == this.ildpCalendarID) {
        //     this.ildpCalendarSelected = element;
        //   }
        // }
        for (let i = parseInt(yearFrom); i <= parseInt(yearTo); i++) {
          this.years.push(i);
        }
      });
    },

    addNewLND() {
      if (this.ildpCalendarID == null) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please select a Calendar Year!";
      } else {
        this.lndSelectionDialog = true;
        this.internal_action = "Add";
        this.$refs.lndSelectionFormref.reset();
      }
    },

    addLnd(yr, lndNum) {
      this.lndSelectionDialog = true;
      this.addToYears.push(yr);
      this.year = yr;
      this.ld_actID = lndNum;
      this.internal_action = "Add";
      this.$refs.lndSelectionFormref.resetValidation();
    },

    addILPD() {
      if (this.$refs.lndSelectionFormref.validate()) {
        for (let i = 0; i < this.addToYears.length; i++) {
          let data = {
            year: this.addToYears[i],
            title: this.title,
            ld_actID: this.ld_actID,
          };
          this.ildpCreated.push(data);
        }
        this.addToYears = [];
        this.year = null;
        this.title = null;
        this.ld_actID = null;
        this.lndSelectionDialog = false;
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please fill out all fields!";
      }
    },

    closeILPDSelection() {
      this.year = null;
      this.title = null;
      this.ld_actID = null;
      this.isEditing = false;
      this.lndSelectionDialog = false;
    },

    updateData() {
      if (this.$refs.lndSelectionFormref.validate()) {
        for (let i = 0; i < this.ildpCreated.length; i++) {
          if (i == this.indexToUpdate) {
            this.ildpCreated[i].title = this.title;
            this.ildpCreated[i].year = this.year;
            this.ildpCreated[i].ld_actID = this.ld_actID;
          }
        }
        this.closeILPDSelection();
      }
      // this.cancel();
    },

    edit(item, index) {
      this.title = item.title;
      this.year = parseInt(item.year);
      this.ld_actID = item.ld_actID;
      this.isEditing = true;
      this.indexToUpdate = index;
      this.lndSelectionDialog = true;
      this.internal_action = "Update";
    },

    proceedDelete() {
      if (this.itemToDelete.id) {
        this.itemsToRemove.push(this.itemToDelete.id);
        this.ildpCreated.splice(this.itemIndexToDelete, 1);
      } else {
        this.ildpCreated.splice(this.itemIndexToDelete, 1);
      }
      this.confirmDeleteDialog = false;
    },

    remove(item, index) {
      this.itemToDelete = item;
      this.itemIndexToDelete = index;

      this.confirmDeleteDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.itemIndexToDelete = null;
      this.confirmDeleteDialog = false;
    },

    confirmSubmit() {
      this.warningMsg = "Are you sure you want to submit this for Approval?";
    },

    async loadAllRequest() {
      // const requests = [
      //   this.axiosCall("/my-ildp/getILDPYear", "GET"),
      //   this.axiosCall("/my-direct-head/getMyDirectHead", "GET"),
      //   this.axiosCall("/user-details/getVicePres", "GET"),
      //   this.axiosCall("/user-details/getCollegePres", "GET"),
      //   this.axiosCall("/user-details/getAllUserDetail", "GET"),
      // ];
      // const results = await Promise.allSettled(requests);

      try {
        const requests = [
          this.axiosCall("/my-ildp/getILDPYear", "GET"),
          this.axiosCall("/my-direct-head/getMyDirectHead", "GET"),
          this.axiosCall("/user-details/getVicePres", "GET"),
          this.axiosCall("/user-details/getCollegePres", "GET"),
          this.axiosCall("/user-details/getAllUserDetail", "GET"),
          this.axiosCall(
            "/positions/" + this.$store.state.emp.positionID,
            "GET",
          ),
          this.axiosCall("/user-details/getDeanDirAboveUsers", "GET"),
        ];

        const [
          ildpYearResponse,
          immResponse,
          vpResponse,
          presResponse,
          userResponse,
          posResponse,
          deanDirRes,
        ] = await Promise.all(requests);
        this.getILDPCalendar(ildpYearResponse);
        this.getDirectHead(immResponse);
        this.getVicePresident(vpResponse);
        this.getPresident(presResponse);
        this.getUsers(userResponse);
        this.getPosition(posResponse);
        this.getDeanDirList(deanDirRes);
        this.cardLoading = false;
      } catch (error) {
        console.error(
          "An error occurred during one of the requests:",
          error.message,
        );
        throw error;
      }
    },

    getDirectHead(res) {
      // this.axiosCall("/my-direct-head/getMyDirectHead", "GET").then((res) => {
      if (res.data) {
        if (res.data.length == 0) {
          this.hasDirectHead = false;
        } else {
          this.hasDirectHead = true;
          this.head_name = this.toTitleCase(res.data[0].name);
          this.head_userID = res.data[0].userID;
        }
      }
      // });
    },

    getPosition(res) {
      if (res) {
        console.log(res.data);
        this.myPosition = res.data;
      }
    },

    getVicePresident(res) {
      // this.axiosCall("/user-details/getVicePres", "GET").then((res) => {
      if (res.data) {
        let data = res.data;
        data.forEach((el, k) => {
          data[k].name = this.toTitleCase(el.name);
        });
        this.vpList = data;
      }
      // });
    },

    getPresident(res) {
      // this.axiosCall("/user-details/getCollegePres", "GET").then((res) => {
      if (res.data) {
        this.president_name = this.toTitleCase(res.data.name);
        this.president_userID = res.data.userID;
      }
      // });
    },

    setDeanDir(data) {
      this.showImm = false;
      let user = this.getUser(data);
      this.dean_userID = user.id;
      this.dean_name = this.toTitleCase(user.name);
    },

    getDeanDir(data) {
      if (data) {
        this.axiosCall("/my-direct-head/getUserDirectHead/" + data, "GET").then(
          (res) => {
            console.log("dasdasss", res.data);

            this.dean_userID = res.data.userID;
            this.dean_name = this.toTitleCase(res.data.name);
          },
        );
      }
    },

    getVP(data) {
      if (data) {
        this.axiosCall("/my-direct-head/getUserDirectHead/" + data, "GET").then(
          (res) => {
            if (res.data.userID == this.president_userID) {
              this.showVP = false;
            } else {
              this.vp_userID = res.data.userID;
            }
          },
        );
      }
    },

    getIsImmediateHeadPresident(data) {
      if (data) {
        this.axiosCall("/my-direct-head/getUserDirectHead/" + data, "GET").then(
          (res) => {
            console.log("dasdaasdasdadadtt", res.data);
            // this.dean_name = this.toTitleCase(res.data.name);
          },
        );
      }
    },

    checkRoles(role) {
      let rolesArr = [1, 3, 4, 5, 6, 7, 8];
      return rolesArr.includes(role);
    },

    getUsers(res) {
      this.usersList = res.data;
    },

    getDeanDirList(res) {
      // this.axiosCall("/user-details/getAllUserDetail", "GET").then((res) => {
      this.deanDirList = res.data;
      console.log("assssd", res.data);
      // });
    },

    getOffice(data) {
      this.axiosCall("/employee/user/" + data, "GET").then((res) => {
        if (res.data.office.office_underID == 1) {
          this.showDir = false;
          this.showVP = false;
        } else {
          if (this.action == "Update") {
            this.dean_userID = this.data.dean_approver.toString();
            this.vp_userID = this.data.vp_approver.toString();
          } else {
            this.getDeanDir(data);
          }
        }
      });
    },

    add() {
      if (this.$refs.MyILDPFormref.validate()) {
        let data = {
          ildp_calendarID: this.ildpCalendarSelected.id,
          ildps: JSON.stringify(this.ildpCreated),
          head_userID: this.showImm ? this.head_userID : null,
          dean_userID: this.showDir ? this.dean_userID : null,
          vp_userID: this.showVP ? this.vp_userID : null,
          president_userID: this.president_userID,
        };

        this.axiosCall("/ildp", "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.dialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.close();
          } else if (res.data.status == 400) {
            this.dialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            // this.close();
          }
        });
      }
    },
    update() {
      let data = {
        ildp_calendarID: this.ildpCalendarID,
        ildps: JSON.stringify(this.ildpCreated),
        head_userID: this.showImm ? this.head_userID : null,
        dean_userID: this.showDir ? this.dean_userID : null,
        vp_userID: this.showVP ? this.vp_userID : null,
        itemsToRemove: JSON.stringify(this.itemsToRemove),
        myIldpID: this.myIldpID,
      };
      this.axiosCall("/ildp/updateILPD", "POST", data).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
          this.close();
          // this.$emit("reloadTable");
        } else if (res.data.status == 400) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          // this.close();
          // this.$emit("reloadTable");
        }
      });
    },

    submit() {
      this.axiosCall("/my-ildp/submitMyILPD/" + this.myIldpID, "PATCH").then(
        (res) => {
          if (res.data.status == 200) {
            this.btnLoading = false;
            this.warningMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.close();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
    },
  },
};
</script>

<style scoped>
.clickme {
  text-decoration: underline;
  cursor: pointer;
  text-underline-offset: 2px;
}
.year {
  border: 1px solid #9e9e9e;
  border-bottom: none;
  border-top: none;
  width: 100%;
}
.lndList {
  display: list-item;

  list-style-position: inside;
}
</style>
